import React from "react";
import { NavLink } from "react-router-dom";
import "./AdminSidebar.css";
import {
  FaTachometerAlt,
  FaBox,
  FaShoppingCart,
  FaUsers,
  FaUserCircle,
  FaBoxOpen,
} from "react-icons/fa";

const AdminSidebar = () => {
  const getActiveClass = ({ isActive }) => (isActive ? "active" : "");
  return (
    <div className="admin-sidebar">
      <h2>Admin Panel</h2>
      <ul>
        <li>
          <NavLink to="/admin" end className={getActiveClass}>
            <FaTachometerAlt style={{ marginRight: "8px" }} />
            Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin/products" className={getActiveClass}>
            <FaBoxOpen style={{ marginRight: "8px" }} />
            Products
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin/orders" className={getActiveClass}>
            <FaShoppingCart style={{ marginRight: "8px" }} />
            Orders
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin/users" className={getActiveClass}>
            <FaUsers style={{ marginRight: "8px" }} />
            Users
          </NavLink>
        </li>
        {/* <li>
          <NavLink to="/admin/payments" className={getActiveClass}>
            <FaUserCircle style={{ marginRight: "8px" }} />
            Profile
          </NavLink>
        </li> */}
        {/* <li>
          <NavLink to="/admin/payments">Payments</NavLink>
        </li> */}
      </ul>
    </div>
  );
};

export default AdminSidebar;
